export enum Path {
  Home = '/',
  City = '/:city',
  ErrorPage = '/404',
  AnyOther = '*',
}
